import React from 'react';
import { Modal, Card } from 'antd';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { GripVertical } from 'lucide-react';

const PathQuestionOrder = ({
  open,
  onClose,
  pathPages = [],
  activePathIds = [],
  onOrderChange
}) => {
  const [orderedIds, setOrderedIds] = React.useState(activePathIds);

  const orderedPages = React.useMemo(() =>
    orderedIds
      .map(id => pathPages.find(page => page.id === id))
      .filter(Boolean),
    [orderedIds, pathPages]
  );

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const sourceIndex = result.source.index;
    const destIndex = result.destination.index;

    if (sourceIndex === destIndex) return;

    const newOrderedIds = Array.from(orderedIds);
    const [movedId] = newOrderedIds.splice(sourceIndex, 1);
    newOrderedIds.splice(destIndex, 0, movedId);

    setOrderedIds(newOrderedIds);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      onCancel={onClose}
    >
      <div className="p-6">
        <h2 className="text-lg font-semibold mb-4">Edit Portfolio Path Order</h2>

        <div className="mb-4">
          <p className="text-sm text-gray-600">
            Drag and drop items to reorder your active portfolio paths.
          </p>
        </div>

        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="portfolio-paths-order">
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className="space-y-2"
              >
                {orderedPages.map((page, index) => (
                  <Draggable
                    key={page.id}
                    draggableId={page.id}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        className={`
                          p-3 rounded-lg border bg-white
                          ${snapshot.isDragging ? 'shadow-lg' : 'shadow-sm'}
                          transition-shadow duration-200
                        `}
                      >
                        <div className="flex items-center gap-3">
                          <div
                            {...provided.dragHandleProps}
                            className="text-gray-400"
                          >
                            <GripVertical size={20} />
                          </div>
                          <div className="flex-1">
                            <div className="font-medium">{page.title}</div>
                          </div>
                          <div className="text-sm text-gray-500">
                            #{index + 1}
                          </div>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-800"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              onOrderChange(orderedIds);
              onClose();
            }}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
          >
            Save Order
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PathQuestionOrder;